import {
  FileFolderType,
  IEditor,
  ROLES_TAB_PATH,
  MODEL_TAB_PATH,
  IFileInfo,
  ITabFlags,
  HTTP_HANDLERS_PATH,
} from '@qodly/shared';

export interface ITreeItem {
  id?: string;
  name: string;
  path: string;
  children?: ITreeItem[];
  type: FileFolderType;
  date?: string;
  size?: number;
  ext?: string;
  error: null | { message: string };
  flags: {
    [key: string]: boolean;
  };
  tipKey?: string;
  config: {
    editor?: IEditor;
    supportedEditors?: IEditor[];
  };
  isRoot?: boolean;
  info?: { [key: string]: any };
}

export interface INodePermissions {
  canRemove: boolean;
  canAdd: boolean;
  canMove: boolean;
  canRename: boolean;
  canDownload: boolean;
  canUpload: boolean;
  canReload: boolean;
  canAddFolder: boolean;
  canDuplicate: boolean;
  canDrag: boolean;
  canDragIn: boolean;
  canTerminate: boolean;
  canRender: boolean;
  canExecute: boolean;
}

export interface INodeFlags {
  hidden: boolean;
  disabled: boolean;
}

export interface INodeAttributes {
  flags: Partial<INodeFlags>;
  permissions: Partial<INodePermissions>;
}

export interface IEditors {
  pattern: string;
  editor: IEditor;
  supportedEditors?: IEditor[];
}

export interface IOpenFilePayload {
  file: IFileInfo;
  inactive?: boolean;
  isNew?: boolean;
  flags?: Pick<ITabFlags, 'enabled' | 'loading' | 'pinned' | 'confirmed'>;
  info?: { [key: string]: string };
}

export const editors: IEditors[] = [
  {
    pattern: ROLES_TAB_PATH,
    editor: {
      key: 'editors:roles',
    },
    supportedEditors: [
      {
        key: 'editors:code',
        config: {
          language: 'json',
          theme: 'vs-dark',
        },
      },
    ],
  },
  {
    pattern: HTTP_HANDLERS_PATH,
    editor: {
      key: 'editors:http-handlers',
    },
    supportedEditors: [
      {
        key: 'editors:code',
        config: { language: 'json' },
      },
    ],
  },
  {
    pattern: MODEL_TAB_PATH,
    editor: {
      key: 'editors:model',
    },
    supportedEditors: [
      {
        key: 'editors:code',
        config: {
          language: 'json',
          theme: 'vs-dark',
        },
      },
    ],
  },
  {
    pattern: '**/*.webform',
    editor: {
      key: 'editors:webforms',
    },
    supportedEditors: [
      {
        key: 'editors:code',
        config: {
          language: 'json',
          theme: 'vs-dark',
        },
      },
    ],
  },
  {
    pattern: '**/*.qodoc',
    editor: {
      key: 'editors:reports',
    },
    supportedEditors: [
      {
        key: 'editors:code',
        config: {
          language: 'json',
          theme: 'vs-dark',
        },
      },
    ],
  },
  {
    pattern: 'Methods/*.4dm',
    editor: {
      key: 'editors:code:method',
      config: {
        theme: 'fd-dark',
        language: '4d',
      },
    },
  },
  {
    pattern: 'Methods/*.4qs',
    editor: {
      key: 'editors:code:method',
      config: {
        theme: 'fd-dark',
        language: '4d',
      },
    },
  },
  {
    pattern: 'Classes/*.4dm',
    editor: {
      key: 'editors:code',
      config: {
        theme: 'fd-dark',
        language: '4d',
      },
    },
  },
  {
    pattern: 'Classes/*.4qs',
    editor: {
      key: 'editors:code',
      config: {
        theme: 'fd-dark',
        language: '4d',
      },
    },
  },
  {
    pattern: '**/*.+(json)',
    editor: {
      key: 'editors:code',
      config: {
        language: 'json',
      },
    },
  },
  {
    pattern: '**/*.+(js)',
    editor: {
      key: 'editors:code',
      config: {
        language: 'js',
      },
    },
  },
  {
    pattern: '**/*.+(css)',
    editor: {
      key: 'editors:code',
      config: {
        language: 'css',
      },
    },
  },
  {
    pattern: '**/*.+(txt)',
    editor: {
      key: 'editors:code',
      config: {
        language: '',
      },
    },
  },
  {
    pattern: 'Debugger/*',
    editor: {
      key: 'editors:code',
      config: {
        theme: 'fd-dark',
        language: '4d',
      },
    },
  },
  {
    pattern: '**/*.+(png|jpeg|jpg|gif|svg)',
    editor: {
      key: 'editors:img',
    },
  },
];

export const extensions: {
  pattern: string;
  type: 'json' | 'text';
}[] = [
  {
    pattern: '**/*.+(json|4DModel|WebForm)',
    type: 'json',
  },
  {
    pattern: '**/*.+(4dm|txt|json|4qs)',
    type: 'text',
  },
];
